import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "../environments/environment.production";
import { DefaultErrorMessage, ErrorMessages } from "../components/catalogoErrores/error-messages";

@Injectable({
  providedIn: 'root'
})
export class GuardarEdicionService {
  private readonly endPointEstatal = `${environment.HOST_EDICION}/guardar-cambios-edicion-estatales`;
  private readonly endPointForaneo = `${environment.HOST_EDICION}/guardar-cambios-edicion-foranea-moral`;

  constructor(private http: HttpClient) {}

  guardarEstatal(payload: any): Observable<any> {
    if (!payload) {
      return throwError(() => this.createValidationError('Payload no puede estar vacío'));
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(this.endPointEstatal, payload, { headers }).pipe(
      catchError(error => this.handleError(error, 'guardarEstatal', payload))
    );
  }

  guardarForaneo(payload: any): Observable<any> {
    if (!payload) {
      return throwError(() => this.createValidationError('Payload no puede estar vacío'));
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(this.endPointForaneo, payload, { headers }).pipe(
      catchError(error => this.handleError(error, 'guardarForaneo', payload))
    );
  }

  private handleError(error: any, method: string, payload: any): Observable<never> {
    const customError = {
      originalError: error,
      timestamp: new Date().toISOString(),
      userMessage: error.error?.descripcionCodigo ||
        ErrorMessages[error.error?.idCodigo] ||
        ErrorMessages[error.status] ||
        DefaultErrorMessage,
      context: {
        endpoint: method === 'guardarEstatal' ? this.endPointEstatal : this.endPointForaneo,
        payload: payload
      }
    };
    console.error(`Error en GuardarEdicionService.${method}:`, customError);
    return throwError(() => customError);
  }

  private createValidationError(message: string): any {
    return {
      type: 'VALIDATION_ERROR',
      message,
      userMessage: message,
      timestamp: new Date().toISOString()
    };
  }
}
